import {
  parseISO,
  format,
  getHours,
  getMinutes,
  getSeconds,
  getMonth,
  getDate,
  getDay,
  isToday,
} from "date-fns";

// export function formatPhoneNumber(number) {
//     // Remove all non-digit characters
//     const cleaned = number.toString().replace(/\D/g, '');

//     // Ensure it's at least 10 digits long
//     if (cleaned.length < 10) {
//         return null;
//     }

//     // Extract last 10 digits
//     const lastTenDigits = cleaned.slice(-10);

//     // Format the number
//     return lastTenDigits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
// }

export function formatPhoneNumber(number) {
  // Remove all non-digit characters
  const cleaned = number.toString().replace(/\D/g, "");

  // Ensure it's at least 10 digits long
  if (cleaned.length < 10) {
    return null;
  }

  // Extract last 10 digits
  const lastTenDigits = cleaned.slice(-10);

  // Format the number as (XXX)-XXX-XXXX
  return lastTenDigits.replace(/(\d{3})(\d{3})(\d{4})/, "($1)-$2-$3");
}

export function getClinicalInfoNames(data) {
  // Check if data is an array
  if (Array.isArray(data)) {
    return data.map((item) => item.clinicalInfoName).join(", ");
  }

  // If data is an object, check if it has a clinicalInfoName property
  if (typeof data === "object" && data !== null && data.clinicalInfoName) {
    return data.clinicalInfoName;
  }

  // Return data as is for other types
  return data;
}

export function getBrowserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function convertDateLastContracted(isoDateString) {
  const dateObj = new Date(isoDateString);

  // Extract date, month, and year
  const day = dateObj.getDate().toString().padStart(2, "0");
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const year = dateObj.getFullYear();

  // Extract hours and minutes
  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");

  // Determine AM/PM and adjust hours
  const amPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format, 0 becomes 12

  // Format the final string
  return `${month}-${day}-${year} ${hours}:${minutes} ${amPm}`;
}

export function convertTimeToLocation(utcTime) {
  const timeZone = getBrowserTimeZone();

  // Parse UTC date correctly

  const date = new Date(utcTime + "Z"); // Ensure it's treated as UTC

  // Convert to target timezone
  const options = {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  let convertedTime = utcTime;

  if (date == "Invalid Date") {
    return convertedTime;
  } else {
    convertedTime = new Intl.DateTimeFormat("en-US", options).format(date);
  }

  return convertedTime;
}

export const getAccessToken = (location) => {
  const urlParams = new URLSearchParams(location.hash.substring(1)); // Remove '#'
  return urlParams.get("access_token");
};

export const convertUTCToLocal = (utcDateStr) => {
  // Ensure the input string ends with 'Z' to indicate UTC
  if (!utcDateStr.endsWith("Z")) {
    utcDateStr += "Z";
  }

  const date = new Date(utcDateStr); // Convert string to Date object
  const localDate = new Date(date.getTime()); // Convert to local timezone

  return {
    localDate: localDate,
    formattedDate: localDate.toLocaleString([], { hour12: false }), // Full formatted date in local timezone
    timeHHmm: localDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }), // Extract HH:mm format in 24-hour format
    //dateOnly: localDate.toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" }), // Extract date in "12 March 2025" format
    dateOnly: format(localDate, "dd MMMM yyyy"),
    hours: localDate.getHours(),
    isToday: isToday(localDate),
    minutes: localDate.getMinutes(),
    seconds: localDate.getSeconds(),
    month: localDate.getMonth() + 1, // Months are 0-based in JS
    day: localDate.getDate(),
    weekDay: localDate.getDay(), // 0 = Sunday, 1 = Monday, etc.
  };
};

export function transcate(str, length) {
  if (str.length > length) {
    return str.slice(0, length) + "...";
  }
  return str;
}

export const redirectUri = "http://localhost:3000/integrations";

export const getInitials = (name) => {
  if (!name || typeof name !== "string") return "";

  const words = name
    .trim()
    .replace(/\s+/g, " ") // Replace multiple spaces with single space
    .split(" ") // Split into words
    .filter((word) => word.length > 0); // Filter out empty strings

  const initials = words.slice(0, 2).map((word) => {
    if (word && word.length > 0) {
      return word[0].toUpperCase();
    }
    return "";
  });

  return initials.join("");
};

export const formatName = (str) =>
  str
    .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special characters
    .replace(/\s+/g, " ") // Replace multiple spaces with single space
    .trim()
    .toLowerCase()
    .replace(/ /g, "_");

export const flattenPermissions = (permObj) => {
  const result = [];

  const recurse = (obj) => {
    for (const key in obj) {
      const value = obj[key];

      if (typeof value === "string") {
        result.push(value); // the actual permission string
      } else if (typeof value === "object") {
        recurse(value);
      }
    }
  };

  recurse(permObj);

  return result;
};
export const format_count = (num) => {
  num = Number(num); // ensure it's numeric

  if (num >= 0 && num <= 9) {
    return num.toString().padStart(2, "0"); // add leading zero
  } else if (num < 10000) {
    return num.toString(); // normal display
  } else if (num < 1000000) {
    // 10K – 999K
    const thousands = Math.floor(num / 1000);
    return num % 1000 === 0 ? `${thousands}K` : `${thousands}K+`;
  } else if (num < 1000000000) {
    // 1M – 999M
    const millions = Math.floor(num / 1000000);
    return num % 1000000 === 0 ? `${millions}M` : `${millions}M+`;
  } else {
    // 1B+
    const billions = Math.floor(num / 1000000000);
    return num % 1000000000 === 0 ? `${billions}B` : `${billions}B+`;
  }
};
